<script lang="ts">
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {getLocalization} from 'core/svelte-context/context';

    export let buttonId: string | null = null;

    const localize = getLocalization();
    let buttonElement: HTMLButtonElement;

    const handleCopyClick = () => {
        navigator.clipboard.writeText(buttonElement.innerText);
    }
</script>

<button class="kp-click-copy"
        id={buttonId}
        bind:this={buttonElement}
        on:click={handleCopyClick}
        use:tooltip={localize(/* @kp-localization commons.ClickToCopy */ 'commons.ClickToCopy')}>

    <slot/>
</button>

<style lang="less">
    .kp-click-copy {
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
        padding: 0;
        margin: 0;
    }
</style>